import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import {
    FormControl, InputLabel, Input, InputAdornment, IconButton
} from "@material-ui/core";
import {connect} from "react-redux";
import Spinner from "react-spinner-material";
import Search from "@material-ui/icons/Search";
import _ from "lodash";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Card2 from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "./../../components/CustomButtons/Button";
import {mapStateToProps, mapDispatchToProps} from "./functions";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "400",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    emptyListMsg: {
        paddingTop: 20,
        paddingBottom: 20,
        margin: 0,
        color: "#0093cb"
    }
};

class Quizzes extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            syncButtonDisabled: false,
            page: 0,
            filterBy: "title",
            searchText: "",
            loading: true,
            syncingQuizzes: [],
            throttleFunc: _.throttle(this.getUserCall, 1000, { 'trailing': true })
        }
    }
    componentDidMount(){
        const { page, searchText, filterBy } = this.state;
        const { rowsPerPage } = this.props;
        this.props.getQuizzes(rowsPerPage, page * rowsPerPage, searchText, filterBy, (res) => {
            this.setState({ loading: false })
        });
    }
    componentDidUpdate(prevProps, prevState){
        const { page, searchText, filterBy } = this.state;
        const { rowsPerPage } = this.props;
        if (prevState.page !== page || prevProps.rowsPerPage !== rowsPerPage) {
            this.setState({loading: true});
            this.props.getQuizzes(rowsPerPage, page * rowsPerPage, searchText, filterBy, (res) => {
                this.setState({ loading: false })
            });
        }
        else if (prevState.searchText !== searchText) {
            // this.setState({ loading: true });
            // this.props.getQuizzes(rowsPerPage, page * rowsPerPage, searchText, filterBy, (res) => {
            //     this.setState({ loading: false })
            // });
        }
    }
    searchClick = () => {
        const { page, searchText, filterBy } = this.state;
        const { rowsPerPage } = this.props;
        this.setState({ loading: true });
        this.props.getQuizzes(rowsPerPage, page * rowsPerPage, searchText, filterBy, (res) => {
            this.setState({ loading: false })
        });
    }
    getUserCall = () => {
        const { page, searchText, filterBy } = this.state;
        const { rowsPerPage } = this.props;
        this.setState({ loading: true });
        this.props.getQuizzes(rowsPerPage, page * rowsPerPage, searchText, filterBy, (res) => {
            this.setState({ loading: false })
        });
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    }
    handleChangeRowsPerPage = event => {
        this.setState({ page: 0 });
        this.props.setRowsPerPage(event.target.value);
    }
    setCourseTitle = event => {
        this.setState({courseTitle: event.target.value})
    }
    setCourseUrl = event => {
        this.setState({courseUrl: event.target.value })
    }
    enableSyncButton = () => {
        this.setState({syncButtonDisabled: false});
    }
    syncAllQuizzes = () => {
        this.setState(state => ({syncButtonDisabled: true}), () => this.props.syncAllQuizzes(this.enableSyncButton));
    }
    syncQuizCall = (quizId) => {
        this.props.syncQuiz(quizId, (id) => {
            this.setState(state => {
                let syncingQuizzes = [...state.syncingQuizzes];
                _.pull(syncingQuizzes, id);
                return {syncingQuizzes}
            })
        })
    }
    syncCourse = (quizId) => {
        this.setState({
            syncingQuizzes: _.concat(this.state.syncingQuizzes, quizId)
        }, () => this.syncQuizCall(quizId))
    }
    searchTextChange = event => {
        this.setState({ searchText: event.target.value })
    }
    render(){
        const { classes, quizzes, rowsPerPage, totalQuizzes } = this.props;
        const { syncButtonDisabled, page, loading, searchText, syncingQuizzes } = this.state;
        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card2>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Quizzes</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer justify="space-between">
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="search">Search</InputLabel>
                                        <Input
                                            id="search"
                                            placeholder="Search by Course"
                                            value={searchText}
                                            onChange={this.searchTextChange}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton color="primary" onClick={this.searchClick}>
                                                        <Search />
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <Button fullWidth color="primary" onClick={this.syncAllQuizzes} disabled={syncButtonDisabled}>Sync All Quizzes</Button>
                                </GridItem>
                            </GridContainer>
                            {loading
                                ?
                                <GridContainer justify="center">
                                    <Spinner size={50} spinnerColor="#0093cb" spinnerWidth={5} visible={true} />
                                </GridContainer>
                                :
                                !_.isEmpty(quizzes)
                                    ?
                                    <Table
                                        tableHeaderColor="primary"
                                        tableHead={tableHead}
                                        tableData={quizzes}
                                        remove={() => { }}
                                        update={this.syncCourse}
                                        page={page}
                                        rowsPerPage={rowsPerPage}
                                        syncingQuizzes={syncingQuizzes}
                                        handleChangePage={this.handleChangePage}
                                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        totalNumber={totalQuizzes}
                                    />
                                    :
                                    <GridContainer justify="center">
                                        <h4 className={classes.emptyListMsg}>No Quiz Found</h4>
                                    </GridContainer>
                            }
                        </CardBody>
                    </Card2>
                </GridItem>
            </GridContainer>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Quizzes));
const tableHead = [
    { id: "id", label: "Sr#", sortable: false },
    // { id: "quizzeserver", label: "Server", sortable: false },
    { id: "title", label: "Title", sortable: false },
    { id: "update", label: "Action", sortable: false },
];